<template>
  <label class="checkbox">
    <slot></slot>
    <input
      @click="toggle()"
      :value="mutable_checked"
      type="checkbox"
      :checked="mutable_checked"
    />
    <span class="checkmark"></span>
  </label>
</template>
<script>
export default {
  name: 'checkbox',
  props: {
    checked: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      mutable_checked: this.checked
    }
  },
  watch: {
    checked (checked) {
      this.mutable_checked = checked
    }
  },
  methods: {
    toggle () {
      this.mutable_checked = !this.mutable_checked
      this.$emit('input', this.mutable_checked)
    }
  }
}
</script>
<style scoped>
  .checkbox {
    height: 25px;
    line-height: 25px;
    display: inline-block;
    position: relative;
    padding-right: 35px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    right: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
  }
  .checkbox:hover input ~ .checkmark {
    background-color: #ccc;
  }
  .checkbox input:checked ~ .checkmark {
    background-color: #2196f3;
  }
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  .checkbox input:checked ~ .checkmark:after {
    display: block;
  }
  .checkbox .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>